module.exports = "/static/Images/en/VerySatisfied.png";